export default "__VITE_ASSET__BvnxWyEM__"